import { render, staticRenderFns } from "./push-notification-popup.vue?vue&type=template&id=2503a91c&scoped=true"
import script from "./push-notification-popup.vue?vue&type=script&lang=js"
export * from "./push-notification-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503a91c",
  null
  
)

export default component.exports